module.exports = __webpack_public_path__ + "img/adv.160a4704.png";